import { useRequestHeaders } from '#app'

import type { Locale } from '@backmarket/http-api'

import { HEADER_CFWORKER_LOCALE, HEADER_NGINX_LOCALE } from '../constants'

/**
 * @private Not to be used outside this module.
 * @returns The locale retrieved from either Cloudflare or Nginx locale headers.
 *
 * @example
 * const locale = useI18nLocaleFromHeaders() // `fr-fr`
 */
export default function useI18nLocaleFromHeaders() {
  const headersLocale = useRequestHeaders([
    HEADER_CFWORKER_LOCALE,
    HEADER_NGINX_LOCALE,
  ])

  return (
    (headersLocale[HEADER_CFWORKER_LOCALE] as Locale) ||
    (headersLocale[HEADER_NGINX_LOCALE] as Locale) ||
    null
  )
}
